import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '@hook/query/queryKeys'
import {useRouter} from 'next/router'
import {getLeaderboardBanners} from '@api/leaderboard/banner/getLeaderboardBanners'

const useQueryGetBanners = () => {
    const router = useRouter()

    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.leaderboard.getBanners(router?.locale),
        staleTime: 120 * 1000,
        cacheTime: 120 * 1000,
        queryFn: async ({pageParam}) => {
            const {data} = await getLeaderboardBanners(router?.locale)
            return {data: data}
        },
    })

    return {
        data: data?.data,
        refetch,
        isLoading,
    }
}

export default useQueryGetBanners
